import React from 'react';
import PropTypes from 'prop-types';
import MaterialChip from 'material-ui/Chip';

const Chip = (props) => {
    const {
        backgroundColor,
        children,
        className,
        containerElement,
        labelColor,
        labelStyle,
        onRequestDelete,
        onTouchTap,
        style,
    } = props;

    return <MaterialChip
        backgroundColor={ backgroundColor }
        className={ className }
        containerElement={ containerElement }
        labelColor={ labelColor }
        labelStyle={ labelStyle }
        onRequestDelete={ onRequestDelete }
        onTouchTap={ onTouchTap }
        style={ style }
    >{ children }</MaterialChip>;
};

Chip.propTypes = {
    backgroundColor: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    containerElement: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
    ]),
    labelColor: PropTypes.string,
    labelStyle: PropTypes.object,
    onRequestDelete: PropTypes.func,
    onTouchTap: PropTypes.func,
    style: PropTypes.object,
};

export default Chip;



// WEBPACK FOOTER //
// ./src/components/ui/chip/Chip.js